/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationQueryKey,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface NotificationsService {
  /** @summary Get Notifications */
  getNotificationsNotificationsGet: {
    /** @summary Get Notifications */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            GetNotificationsNotificationsGetSchema,
            GetNotificationsNotificationsGetParameters,
            TMeta,
            TSignal
          >
        | (QueryFnOptionsByParameters<GetNotificationsNotificationsGetParameters, TMeta, TSignal> | void),
      client?: (
        schema: GetNotificationsNotificationsGetSchema,
        options: {
          parameters: GetNotificationsNotificationsGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<GetNotificationsNotificationsGetData, GetNotificationsNotificationsGetError>>
    ): Promise<RequestFnResponse<GetNotificationsNotificationsGetData, GetNotificationsNotificationsGetError>>;
    /** @summary Get Notifications */
    getQueryKey(
      parameters: DeepReadonly<GetNotificationsNotificationsGetParameters> | void
    ): ServiceOperationQueryKey<GetNotificationsNotificationsGetSchema, GetNotificationsNotificationsGetParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Notifications
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.notificationsService.getNotificationsNotificationsGet.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.notificationsService.getNotificationsNotificationsGet.useQuery({
     *     query: {
     *         page: page
     *     }
     * })
     * ```
     */
    useQuery<TData = GetNotificationsNotificationsGetData>(
      parameters:
        | ServiceOperationQueryKey<GetNotificationsNotificationsGetSchema, GetNotificationsNotificationsGetParameters>
        | (DeepReadonly<GetNotificationsNotificationsGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          GetNotificationsNotificationsGetData,
          GetNotificationsNotificationsGetError,
          TData,
          ServiceOperationQueryKey<GetNotificationsNotificationsGetSchema, GetNotificationsNotificationsGetParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetNotificationsNotificationsGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Notifications
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.notificationsService.getNotificationsNotificationsGet.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.notificationsService.getNotificationsNotificationsGet.useQuery({
     *     query: {
     *         page: page
     *     }
     * })
     * ```
     */
    useQuery<TData = GetNotificationsNotificationsGetData>(
      parameters:
        | ServiceOperationQueryKey<GetNotificationsNotificationsGetSchema, GetNotificationsNotificationsGetParameters>
        | (DeepReadonly<GetNotificationsNotificationsGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          GetNotificationsNotificationsGetData,
          GetNotificationsNotificationsGetError,
          TData,
          ServiceOperationQueryKey<GetNotificationsNotificationsGetSchema, GetNotificationsNotificationsGetParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetNotificationsNotificationsGetError>>;
    /** @summary Get Notifications */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetNotificationsNotificationsGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<
      GetNotificationsNotificationsGetSchema,
      GetNotificationsNotificationsGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Notifications
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.notificationsService.getNotificationsNotificationsGet.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             page: initialPage
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetNotificationsNotificationsGetParameters,
      TQueryFnData = GetNotificationsNotificationsGetData,
      TData = OperationInfiniteData<TQueryFnData, GetNotificationsNotificationsGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetNotificationsNotificationsGetSchema,
            GetNotificationsNotificationsGetParameters
          >
        | (DeepReadonly<GetNotificationsNotificationsGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetNotificationsNotificationsGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetNotificationsNotificationsGetSchema,
            GetNotificationsNotificationsGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetNotificationsNotificationsGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Notifications
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.notificationsService.getNotificationsNotificationsGet.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             page: initialPage
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetNotificationsNotificationsGetParameters,
      TQueryFnData = GetNotificationsNotificationsGetData,
      TData = OperationInfiniteData<TQueryFnData, GetNotificationsNotificationsGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetNotificationsNotificationsGetSchema,
            GetNotificationsNotificationsGetParameters
          >
        | (DeepReadonly<GetNotificationsNotificationsGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetNotificationsNotificationsGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetNotificationsNotificationsGetSchema,
            GetNotificationsNotificationsGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetNotificationsNotificationsGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetNotificationsNotificationsGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get Notifications
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getNotificationsNotificationsGetTotal = qraft.notificationsService.getNotificationsNotificationsGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getNotificationsNotificationsGetByParametersTotal = qraft.notificationsService.getNotificationsNotificationsGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         query: {
     *             page: page
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetNotificationsNotificationsGetSchema,
            GetNotificationsNotificationsGetData,
            TInfinite,
            GetNotificationsNotificationsGetParameters,
            GetNotificationsNotificationsGetError
          >
        | QueryFiltersByQueryKey<
            GetNotificationsNotificationsGetSchema,
            GetNotificationsNotificationsGetData,
            TInfinite,
            GetNotificationsNotificationsGetParameters,
            GetNotificationsNotificationsGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get Notifications
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getNotificationsNotificationsGetResults = qraft.notificationsService.getNotificationsNotificationsGet.useQueries({
     *     queries: [
     *         {
     *             query: {
     *                 page: page1
     *             }
     *         },
     *         {
     *             query: {
     *                 page: page2
     *             }
     *         }
     *     ]
     * });
     * getNotificationsNotificationsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getNotificationsNotificationsGetCombinedResults = qraft.notificationsService.getNotificationsNotificationsGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 page: page1
     *             }
     *         },
     *         {
     *             query: {
     *                 page: page2
     *             }
     *         }
     *     ]
     * });
     * getNotificationsNotificationsGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetNotificationsNotificationsGetSchema,
          GetNotificationsNotificationsGetParameters,
          GetNotificationsNotificationsGetData,
          GetNotificationsNotificationsGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<GetNotificationsNotificationsGetData, GetNotificationsNotificationsGetError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<UseQueryResult<GetNotificationsNotificationsGetData, GetNotificationsNotificationsGetError>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get Notifications
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.notificationsService.getNotificationsNotificationsGet.useSuspenseQuery()
     * ```
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.notificationsService.getNotificationsNotificationsGet.useSuspenseQuery({
     *     query: {
     *         page: page
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetNotificationsNotificationsGetData>(
      parameters:
        | ServiceOperationQueryKey<GetNotificationsNotificationsGetSchema, GetNotificationsNotificationsGetParameters>
        | (DeepReadonly<GetNotificationsNotificationsGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          GetNotificationsNotificationsGetData,
          GetNotificationsNotificationsGetError,
          TData,
          ServiceOperationQueryKey<GetNotificationsNotificationsGetSchema, GetNotificationsNotificationsGetParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetNotificationsNotificationsGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get Notifications
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.notificationsService.getNotificationsNotificationsGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             page: initialPage
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends GetNotificationsNotificationsGetParameters,
      TData = GetNotificationsNotificationsGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetNotificationsNotificationsGetSchema,
            GetNotificationsNotificationsGetParameters
          >
        | (DeepReadonly<GetNotificationsNotificationsGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetNotificationsNotificationsGetData,
          GetNotificationsNotificationsGetError,
          OperationInfiniteData<TData, GetNotificationsNotificationsGetParameters>,
          ServiceOperationInfiniteQueryKey<
            GetNotificationsNotificationsGetSchema,
            GetNotificationsNotificationsGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetNotificationsNotificationsGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetNotificationsNotificationsGetParameters>,
      OperationError<GetNotificationsNotificationsGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get Notifications
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getNotificationsNotificationsGetData = qraft.notificationsService.getNotificationsNotificationsGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             query: {
     *                 page: page1
     *             }
     *         },
     *         {
     *             query: {
     *                 page: page2
     *             }
     *         }
     *     ]
     * });
     * getNotificationsNotificationsGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getNotificationsNotificationsGetCombinedData = qraft.notificationsService.getNotificationsNotificationsGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 page: page1
     *             }
     *         },
     *         {
     *             query: {
     *                 page: page2
     *             }
     *         }
     *     ]
     * });
     * getNotificationsNotificationsGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetNotificationsNotificationsGetSchema,
          GetNotificationsNotificationsGetParameters,
          GetNotificationsNotificationsGetData,
          GetNotificationsNotificationsGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<GetNotificationsNotificationsGetData, GetNotificationsNotificationsGetError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<GetNotificationsNotificationsGetData, GetNotificationsNotificationsGetError>,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Get Notifications */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetNotificationsNotificationsGetSchema,
        GetNotificationsNotificationsGetData,
        GetNotificationsNotificationsGetParameters,
        GetNotificationsNotificationsGetError
      > | void
    ): Promise<GetNotificationsNotificationsGetData>;
    /** @summary Get Notifications */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetNotificationsNotificationsGetSchema,
        GetNotificationsNotificationsGetData,
        GetNotificationsNotificationsGetParameters,
        GetNotificationsNotificationsGetError
      > | void
    ): Promise<void>;
    /** @summary Get Notifications */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetNotificationsNotificationsGetSchema,
        GetNotificationsNotificationsGetData,
        GetNotificationsNotificationsGetParameters,
        GetNotificationsNotificationsGetError
      > | void
    ): Promise<GetNotificationsNotificationsGetData>;
    /** @summary Get Notifications */
    fetchInfiniteQuery<TPageParam extends GetNotificationsNotificationsGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetNotificationsNotificationsGetSchema,
        GetNotificationsNotificationsGetData,
        GetNotificationsNotificationsGetParameters,
        DeepReadonly<TPageParam>,
        GetNotificationsNotificationsGetError
      > | void
    ): Promise<OperationInfiniteData<GetNotificationsNotificationsGetData, GetNotificationsNotificationsGetParameters>>;
    /** @summary Get Notifications */
    prefetchInfiniteQuery<TPageParam extends GetNotificationsNotificationsGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetNotificationsNotificationsGetSchema,
        GetNotificationsNotificationsGetData,
        GetNotificationsNotificationsGetParameters,
        DeepReadonly<TPageParam>,
        GetNotificationsNotificationsGetError
      > | void
    ): Promise<void>;
    /** @summary Get Notifications */
    ensureInfiniteQueryData<TPageParam extends GetNotificationsNotificationsGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetNotificationsNotificationsGetSchema,
        GetNotificationsNotificationsGetData,
        GetNotificationsNotificationsGetParameters,
        DeepReadonly<TPageParam>,
        GetNotificationsNotificationsGetError
      > | void
    ): Promise<OperationInfiniteData<GetNotificationsNotificationsGetData, GetNotificationsNotificationsGetParameters>>;
    /** @summary Get Notifications */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<GetNotificationsNotificationsGetSchema, GetNotificationsNotificationsGetParameters>
        | (DeepReadonly<GetNotificationsNotificationsGetParameters> | void)
    ): GetNotificationsNotificationsGetData | undefined;
    /** @summary Get Notifications */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetNotificationsNotificationsGetSchema,
            GetNotificationsNotificationsGetParameters
          >
        | (DeepReadonly<GetNotificationsNotificationsGetParameters> | void)
    ):
      | OperationInfiniteData<GetNotificationsNotificationsGetData, GetNotificationsNotificationsGetParameters>
      | undefined;
    /** @summary Get Notifications */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetNotificationsNotificationsGetSchema,
            GetNotificationsNotificationsGetData,
            TInfinite,
            GetNotificationsNotificationsGetParameters,
            GetNotificationsNotificationsGetError
          >
        | QueryFiltersByQueryKey<
            GetNotificationsNotificationsGetSchema,
            GetNotificationsNotificationsGetData,
            TInfinite,
            GetNotificationsNotificationsGetParameters,
            GetNotificationsNotificationsGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetNotificationsNotificationsGetSchema,
              GetNotificationsNotificationsGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    GetNotificationsNotificationsGetData,
                    GetNotificationsNotificationsGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              GetNotificationsNotificationsGetSchema,
              GetNotificationsNotificationsGetParameters
            >,
            data: GetNotificationsNotificationsGetData | undefined,
          ]
        >;
    /** @summary Get Notifications */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<GetNotificationsNotificationsGetSchema, GetNotificationsNotificationsGetParameters>
        | (DeepReadonly<GetNotificationsNotificationsGetParameters> | void)
    ): QueryState<GetNotificationsNotificationsGetData, GetNotificationsNotificationsGetError> | undefined;
    /** @summary Get Notifications */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetNotificationsNotificationsGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetNotificationsNotificationsGetSchema,
            GetNotificationsNotificationsGetParameters
          >
        | void
    ):
      | QueryState<
          OperationInfiniteData<GetNotificationsNotificationsGetData, GetNotificationsNotificationsGetParameters>,
          GetNotificationsNotificationsGetError
        >
      | undefined;
    /** @summary Get Notifications */
    setQueryData(
      parameters:
        | (DeepReadonly<GetNotificationsNotificationsGetParameters> | undefined)
        | ServiceOperationQueryKey<GetNotificationsNotificationsGetSchema, GetNotificationsNotificationsGetParameters>,
      updater: Updater<
        NoInfer<GetNotificationsNotificationsGetData> | undefined,
        NoInfer<DeepReadonly<GetNotificationsNotificationsGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetNotificationsNotificationsGetData | undefined;
    /** @summary Get Notifications */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<GetNotificationsNotificationsGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<
            GetNotificationsNotificationsGetSchema,
            GetNotificationsNotificationsGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<GetNotificationsNotificationsGetData, GetNotificationsNotificationsGetParameters>
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<GetNotificationsNotificationsGetData, GetNotificationsNotificationsGetParameters>
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<GetNotificationsNotificationsGetData, GetNotificationsNotificationsGetParameters>
      | undefined;
    /** @summary Get Notifications */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetNotificationsNotificationsGetSchema,
            GetNotificationsNotificationsGetData,
            TInfinite,
            GetNotificationsNotificationsGetParameters,
            GetNotificationsNotificationsGetError
          >
        | QueryFiltersByQueryKey<
            GetNotificationsNotificationsGetSchema,
            GetNotificationsNotificationsGetData,
            TInfinite,
            GetNotificationsNotificationsGetParameters,
            GetNotificationsNotificationsGetError
          >,
      updater: Updater<
        NoInfer<GetNotificationsNotificationsGetData> | undefined,
        NoInfer<GetNotificationsNotificationsGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetNotificationsNotificationsGetData | undefined>;
    /** @summary Get Notifications */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetNotificationsNotificationsGetSchema,
        GetNotificationsNotificationsGetData,
        TInfinite,
        GetNotificationsNotificationsGetParameters,
        GetNotificationsNotificationsGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Get Notifications */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetNotificationsNotificationsGetSchema,
            GetNotificationsNotificationsGetData,
            TInfinite,
            GetNotificationsNotificationsGetParameters,
            GetNotificationsNotificationsGetError
          >
        | QueryFiltersByQueryKey<
            GetNotificationsNotificationsGetSchema,
            GetNotificationsNotificationsGetData,
            TInfinite,
            GetNotificationsNotificationsGetParameters,
            GetNotificationsNotificationsGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Get Notifications */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetNotificationsNotificationsGetSchema,
            GetNotificationsNotificationsGetData,
            TInfinite,
            GetNotificationsNotificationsGetParameters,
            GetNotificationsNotificationsGetError
          >
        | QueryFiltersByQueryKey<
            GetNotificationsNotificationsGetSchema,
            GetNotificationsNotificationsGetData,
            TInfinite,
            GetNotificationsNotificationsGetParameters,
            GetNotificationsNotificationsGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Get Notifications */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetNotificationsNotificationsGetSchema,
            GetNotificationsNotificationsGetData,
            TInfinite,
            GetNotificationsNotificationsGetParameters,
            GetNotificationsNotificationsGetError
          >
        | QueryFiltersByQueryKey<
            GetNotificationsNotificationsGetSchema,
            GetNotificationsNotificationsGetData,
            TInfinite,
            GetNotificationsNotificationsGetParameters,
            GetNotificationsNotificationsGetError
          >
    ): void;
    /** @summary Get Notifications */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetNotificationsNotificationsGetSchema,
            GetNotificationsNotificationsGetData,
            TInfinite,
            GetNotificationsNotificationsGetParameters,
            GetNotificationsNotificationsGetError
          >
        | QueryFiltersByQueryKey<
            GetNotificationsNotificationsGetSchema,
            GetNotificationsNotificationsGetData,
            TInfinite,
            GetNotificationsNotificationsGetParameters,
            GetNotificationsNotificationsGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Get Notifications */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetNotificationsNotificationsGetSchema,
            GetNotificationsNotificationsGetData,
            TInfinite,
            GetNotificationsNotificationsGetParameters,
            GetNotificationsNotificationsGetError
          >
        | QueryFiltersByQueryKey<
            GetNotificationsNotificationsGetSchema,
            GetNotificationsNotificationsGetData,
            TInfinite,
            GetNotificationsNotificationsGetParameters,
            GetNotificationsNotificationsGetError
          >
    ): number;
    schema: GetNotificationsNotificationsGetSchema;
    types: {
      parameters: GetNotificationsNotificationsGetParameters;
      data: GetNotificationsNotificationsGetData;
      error: GetNotificationsNotificationsGetError;
    };
  };
  /** @summary Get Notification */
  getNotificationNotificationsNotificationIdGet: {
    /** @summary Get Notification */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            GetNotificationNotificationsNotificationIdGetSchema,
            GetNotificationNotificationsNotificationIdGetParameters,
            TMeta,
            TSignal
          >
        | QueryFnOptionsByParameters<GetNotificationNotificationsNotificationIdGetParameters, TMeta, TSignal>,
      client?: (
        schema: GetNotificationNotificationsNotificationIdGetSchema,
        options: {
          parameters: GetNotificationNotificationsNotificationIdGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<
          GetNotificationNotificationsNotificationIdGetData,
          GetNotificationNotificationsNotificationIdGetError
        >
      >
    ): Promise<
      RequestFnResponse<
        GetNotificationNotificationsNotificationIdGetData,
        GetNotificationNotificationsNotificationIdGetError
      >
    >;
    /** @summary Get Notification */
    getQueryKey(
      parameters: DeepReadonly<GetNotificationNotificationsNotificationIdGetParameters>
    ): ServiceOperationQueryKey<
      GetNotificationNotificationsNotificationIdGetSchema,
      GetNotificationNotificationsNotificationIdGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Notification
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.notificationsService.getNotificationNotificationsNotificationIdGet.useQuery({
     *     path: {
     *         notification_id: notificationId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetNotificationNotificationsNotificationIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetNotificationNotificationsNotificationIdGetSchema,
            GetNotificationNotificationsNotificationIdGetParameters
          >
        | DeepReadonly<GetNotificationNotificationsNotificationIdGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetNotificationNotificationsNotificationIdGetData,
          GetNotificationNotificationsNotificationIdGetError,
          TData,
          ServiceOperationQueryKey<
            GetNotificationNotificationsNotificationIdGetSchema,
            GetNotificationNotificationsNotificationIdGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetNotificationNotificationsNotificationIdGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Notification
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.notificationsService.getNotificationNotificationsNotificationIdGet.useQuery({
     *     path: {
     *         notification_id: notificationId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetNotificationNotificationsNotificationIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetNotificationNotificationsNotificationIdGetSchema,
            GetNotificationNotificationsNotificationIdGetParameters
          >
        | DeepReadonly<GetNotificationNotificationsNotificationIdGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetNotificationNotificationsNotificationIdGetData,
          GetNotificationNotificationsNotificationIdGetError,
          TData,
          ServiceOperationQueryKey<
            GetNotificationNotificationsNotificationIdGetSchema,
            GetNotificationNotificationsNotificationIdGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetNotificationNotificationsNotificationIdGetError>>;
    /** @summary Get Notification */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetNotificationNotificationsNotificationIdGetParameters>
    ): ServiceOperationInfiniteQueryKey<
      GetNotificationNotificationsNotificationIdGetSchema,
      GetNotificationNotificationsNotificationIdGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Notification
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.notificationsService.getNotificationNotificationsNotificationIdGet.useInfiniteQuery({
     *     path: {
     *         notification_id: notificationId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetNotificationNotificationsNotificationIdGetParameters,
      TQueryFnData = GetNotificationNotificationsNotificationIdGetData,
      TData = OperationInfiniteData<TQueryFnData, GetNotificationNotificationsNotificationIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetNotificationNotificationsNotificationIdGetSchema,
            GetNotificationNotificationsNotificationIdGetParameters
          >
        | DeepReadonly<GetNotificationNotificationsNotificationIdGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetNotificationNotificationsNotificationIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetNotificationNotificationsNotificationIdGetSchema,
            GetNotificationNotificationsNotificationIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetNotificationNotificationsNotificationIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Notification
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.notificationsService.getNotificationNotificationsNotificationIdGet.useInfiniteQuery({
     *     path: {
     *         notification_id: notificationId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetNotificationNotificationsNotificationIdGetParameters,
      TQueryFnData = GetNotificationNotificationsNotificationIdGetData,
      TData = OperationInfiniteData<TQueryFnData, GetNotificationNotificationsNotificationIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetNotificationNotificationsNotificationIdGetSchema,
            GetNotificationNotificationsNotificationIdGetParameters
          >
        | DeepReadonly<GetNotificationNotificationsNotificationIdGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetNotificationNotificationsNotificationIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetNotificationNotificationsNotificationIdGetSchema,
            GetNotificationNotificationsNotificationIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetNotificationNotificationsNotificationIdGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetNotificationNotificationsNotificationIdGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get Notification
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getNotificationNotificationsNotificationIdGetTotal = qraft.notificationsService.getNotificationNotificationsNotificationIdGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getNotificationNotificationsNotificationIdGetByParametersTotal = qraft.notificationsService.getNotificationNotificationsNotificationIdGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             notification_id: notificationId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetNotificationNotificationsNotificationIdGetSchema,
            GetNotificationNotificationsNotificationIdGetData,
            TInfinite,
            GetNotificationNotificationsNotificationIdGetParameters,
            GetNotificationNotificationsNotificationIdGetError
          >
        | QueryFiltersByQueryKey<
            GetNotificationNotificationsNotificationIdGetSchema,
            GetNotificationNotificationsNotificationIdGetData,
            TInfinite,
            GetNotificationNotificationsNotificationIdGetParameters,
            GetNotificationNotificationsNotificationIdGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get Notification
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getNotificationNotificationsNotificationIdGetResults = qraft.notificationsService.getNotificationNotificationsNotificationIdGet.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 notification_id: notificationId1
     *             }
     *         },
     *         {
     *             path: {
     *                 notification_id: notificationId2
     *             }
     *         }
     *     ]
     * });
     * getNotificationNotificationsNotificationIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getNotificationNotificationsNotificationIdGetCombinedResults = qraft.notificationsService.getNotificationNotificationsNotificationIdGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 notification_id: notificationId1
     *             }
     *         },
     *         {
     *             path: {
     *                 notification_id: notificationId2
     *             }
     *         }
     *     ]
     * });
     * getNotificationNotificationsNotificationIdGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetNotificationNotificationsNotificationIdGetSchema,
          GetNotificationNotificationsNotificationIdGetParameters,
          GetNotificationNotificationsNotificationIdGetData,
          GetNotificationNotificationsNotificationIdGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<
          GetNotificationNotificationsNotificationIdGetData,
          GetNotificationNotificationsNotificationIdGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<
            GetNotificationNotificationsNotificationIdGetData,
            GetNotificationNotificationsNotificationIdGetError
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get Notification
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.notificationsService.getNotificationNotificationsNotificationIdGet.useSuspenseQuery({
     *     path: {
     *         notification_id: notificationId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetNotificationNotificationsNotificationIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetNotificationNotificationsNotificationIdGetSchema,
            GetNotificationNotificationsNotificationIdGetParameters
          >
        | DeepReadonly<GetNotificationNotificationsNotificationIdGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetNotificationNotificationsNotificationIdGetData,
          GetNotificationNotificationsNotificationIdGetError,
          TData,
          ServiceOperationQueryKey<
            GetNotificationNotificationsNotificationIdGetSchema,
            GetNotificationNotificationsNotificationIdGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetNotificationNotificationsNotificationIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get Notification
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.notificationsService.getNotificationNotificationsNotificationIdGet.useSuspenseInfiniteQuery({
     *     path: {
     *         notification_id: notificationId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends GetNotificationNotificationsNotificationIdGetParameters,
      TData = GetNotificationNotificationsNotificationIdGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetNotificationNotificationsNotificationIdGetSchema,
            GetNotificationNotificationsNotificationIdGetParameters
          >
        | DeepReadonly<GetNotificationNotificationsNotificationIdGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetNotificationNotificationsNotificationIdGetData,
          GetNotificationNotificationsNotificationIdGetError,
          OperationInfiniteData<TData, GetNotificationNotificationsNotificationIdGetParameters>,
          ServiceOperationInfiniteQueryKey<
            GetNotificationNotificationsNotificationIdGetSchema,
            GetNotificationNotificationsNotificationIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetNotificationNotificationsNotificationIdGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetNotificationNotificationsNotificationIdGetParameters>,
      OperationError<GetNotificationNotificationsNotificationIdGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get Notification
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getNotificationNotificationsNotificationIdGetData = qraft.notificationsService.getNotificationNotificationsNotificationIdGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 notification_id: notificationId1
     *             }
     *         },
     *         {
     *             path: {
     *                 notification_id: notificationId2
     *             }
     *         }
     *     ]
     * });
     * getNotificationNotificationsNotificationIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getNotificationNotificationsNotificationIdGetCombinedData = qraft.notificationsService.getNotificationNotificationsNotificationIdGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 notification_id: notificationId1
     *             }
     *         },
     *         {
     *             path: {
     *                 notification_id: notificationId2
     *             }
     *         }
     *     ]
     * });
     * getNotificationNotificationsNotificationIdGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetNotificationNotificationsNotificationIdGetSchema,
          GetNotificationNotificationsNotificationIdGetParameters,
          GetNotificationNotificationsNotificationIdGetData,
          GetNotificationNotificationsNotificationIdGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<
          GetNotificationNotificationsNotificationIdGetData,
          GetNotificationNotificationsNotificationIdGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<
              GetNotificationNotificationsNotificationIdGetData,
              GetNotificationNotificationsNotificationIdGetError
            >,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Get Notification */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetNotificationNotificationsNotificationIdGetSchema,
        GetNotificationNotificationsNotificationIdGetData,
        GetNotificationNotificationsNotificationIdGetParameters,
        GetNotificationNotificationsNotificationIdGetError
      >
    ): Promise<GetNotificationNotificationsNotificationIdGetData>;
    /** @summary Get Notification */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetNotificationNotificationsNotificationIdGetSchema,
        GetNotificationNotificationsNotificationIdGetData,
        GetNotificationNotificationsNotificationIdGetParameters,
        GetNotificationNotificationsNotificationIdGetError
      >
    ): Promise<void>;
    /** @summary Get Notification */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetNotificationNotificationsNotificationIdGetSchema,
        GetNotificationNotificationsNotificationIdGetData,
        GetNotificationNotificationsNotificationIdGetParameters,
        GetNotificationNotificationsNotificationIdGetError
      >
    ): Promise<GetNotificationNotificationsNotificationIdGetData>;
    /** @summary Get Notification */
    fetchInfiniteQuery<TPageParam extends GetNotificationNotificationsNotificationIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetNotificationNotificationsNotificationIdGetSchema,
        GetNotificationNotificationsNotificationIdGetData,
        GetNotificationNotificationsNotificationIdGetParameters,
        DeepReadonly<TPageParam>,
        GetNotificationNotificationsNotificationIdGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetNotificationNotificationsNotificationIdGetData,
        GetNotificationNotificationsNotificationIdGetParameters
      >
    >;
    /** @summary Get Notification */
    prefetchInfiniteQuery<TPageParam extends GetNotificationNotificationsNotificationIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetNotificationNotificationsNotificationIdGetSchema,
        GetNotificationNotificationsNotificationIdGetData,
        GetNotificationNotificationsNotificationIdGetParameters,
        DeepReadonly<TPageParam>,
        GetNotificationNotificationsNotificationIdGetError
      >
    ): Promise<void>;
    /** @summary Get Notification */
    ensureInfiniteQueryData<TPageParam extends GetNotificationNotificationsNotificationIdGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetNotificationNotificationsNotificationIdGetSchema,
        GetNotificationNotificationsNotificationIdGetData,
        GetNotificationNotificationsNotificationIdGetParameters,
        DeepReadonly<TPageParam>,
        GetNotificationNotificationsNotificationIdGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetNotificationNotificationsNotificationIdGetData,
        GetNotificationNotificationsNotificationIdGetParameters
      >
    >;
    /** @summary Get Notification */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            GetNotificationNotificationsNotificationIdGetSchema,
            GetNotificationNotificationsNotificationIdGetParameters
          >
        | DeepReadonly<GetNotificationNotificationsNotificationIdGetParameters>
    ): GetNotificationNotificationsNotificationIdGetData | undefined;
    /** @summary Get Notification */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetNotificationNotificationsNotificationIdGetSchema,
            GetNotificationNotificationsNotificationIdGetParameters
          >
        | DeepReadonly<GetNotificationNotificationsNotificationIdGetParameters>
    ):
      | OperationInfiniteData<
          GetNotificationNotificationsNotificationIdGetData,
          GetNotificationNotificationsNotificationIdGetParameters
        >
      | undefined;
    /** @summary Get Notification */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetNotificationNotificationsNotificationIdGetSchema,
            GetNotificationNotificationsNotificationIdGetData,
            TInfinite,
            GetNotificationNotificationsNotificationIdGetParameters,
            GetNotificationNotificationsNotificationIdGetError
          >
        | QueryFiltersByQueryKey<
            GetNotificationNotificationsNotificationIdGetSchema,
            GetNotificationNotificationsNotificationIdGetData,
            TInfinite,
            GetNotificationNotificationsNotificationIdGetParameters,
            GetNotificationNotificationsNotificationIdGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetNotificationNotificationsNotificationIdGetSchema,
              GetNotificationNotificationsNotificationIdGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    GetNotificationNotificationsNotificationIdGetData,
                    GetNotificationNotificationsNotificationIdGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              GetNotificationNotificationsNotificationIdGetSchema,
              GetNotificationNotificationsNotificationIdGetParameters
            >,
            data: GetNotificationNotificationsNotificationIdGetData | undefined,
          ]
        >;
    /** @summary Get Notification */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            GetNotificationNotificationsNotificationIdGetSchema,
            GetNotificationNotificationsNotificationIdGetParameters
          >
        | DeepReadonly<GetNotificationNotificationsNotificationIdGetParameters>
    ):
      | QueryState<
          GetNotificationNotificationsNotificationIdGetData,
          GetNotificationNotificationsNotificationIdGetError
        >
      | undefined;
    /** @summary Get Notification */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetNotificationNotificationsNotificationIdGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetNotificationNotificationsNotificationIdGetSchema,
            GetNotificationNotificationsNotificationIdGetParameters
          >
    ):
      | QueryState<
          OperationInfiniteData<
            GetNotificationNotificationsNotificationIdGetData,
            GetNotificationNotificationsNotificationIdGetParameters
          >,
          GetNotificationNotificationsNotificationIdGetError
        >
      | undefined;
    /** @summary Get Notification */
    setQueryData(
      parameters:
        | DeepReadonly<GetNotificationNotificationsNotificationIdGetParameters>
        | ServiceOperationQueryKey<
            GetNotificationNotificationsNotificationIdGetSchema,
            GetNotificationNotificationsNotificationIdGetParameters
          >,
      updater: Updater<
        NoInfer<GetNotificationNotificationsNotificationIdGetData> | undefined,
        NoInfer<DeepReadonly<GetNotificationNotificationsNotificationIdGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetNotificationNotificationsNotificationIdGetData | undefined;
    /** @summary Get Notification */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetNotificationNotificationsNotificationIdGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetNotificationNotificationsNotificationIdGetSchema,
            GetNotificationNotificationsNotificationIdGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              GetNotificationNotificationsNotificationIdGetData,
              GetNotificationNotificationsNotificationIdGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                GetNotificationNotificationsNotificationIdGetData,
                GetNotificationNotificationsNotificationIdGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<
          GetNotificationNotificationsNotificationIdGetData,
          GetNotificationNotificationsNotificationIdGetParameters
        >
      | undefined;
    /** @summary Get Notification */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetNotificationNotificationsNotificationIdGetSchema,
            GetNotificationNotificationsNotificationIdGetData,
            TInfinite,
            GetNotificationNotificationsNotificationIdGetParameters,
            GetNotificationNotificationsNotificationIdGetError
          >
        | QueryFiltersByQueryKey<
            GetNotificationNotificationsNotificationIdGetSchema,
            GetNotificationNotificationsNotificationIdGetData,
            TInfinite,
            GetNotificationNotificationsNotificationIdGetParameters,
            GetNotificationNotificationsNotificationIdGetError
          >,
      updater: Updater<
        NoInfer<GetNotificationNotificationsNotificationIdGetData> | undefined,
        NoInfer<GetNotificationNotificationsNotificationIdGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetNotificationNotificationsNotificationIdGetData | undefined>;
    /** @summary Get Notification */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetNotificationNotificationsNotificationIdGetSchema,
        GetNotificationNotificationsNotificationIdGetData,
        TInfinite,
        GetNotificationNotificationsNotificationIdGetParameters,
        GetNotificationNotificationsNotificationIdGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Get Notification */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetNotificationNotificationsNotificationIdGetSchema,
            GetNotificationNotificationsNotificationIdGetData,
            TInfinite,
            GetNotificationNotificationsNotificationIdGetParameters,
            GetNotificationNotificationsNotificationIdGetError
          >
        | QueryFiltersByQueryKey<
            GetNotificationNotificationsNotificationIdGetSchema,
            GetNotificationNotificationsNotificationIdGetData,
            TInfinite,
            GetNotificationNotificationsNotificationIdGetParameters,
            GetNotificationNotificationsNotificationIdGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Get Notification */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetNotificationNotificationsNotificationIdGetSchema,
            GetNotificationNotificationsNotificationIdGetData,
            TInfinite,
            GetNotificationNotificationsNotificationIdGetParameters,
            GetNotificationNotificationsNotificationIdGetError
          >
        | QueryFiltersByQueryKey<
            GetNotificationNotificationsNotificationIdGetSchema,
            GetNotificationNotificationsNotificationIdGetData,
            TInfinite,
            GetNotificationNotificationsNotificationIdGetParameters,
            GetNotificationNotificationsNotificationIdGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Get Notification */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetNotificationNotificationsNotificationIdGetSchema,
            GetNotificationNotificationsNotificationIdGetData,
            TInfinite,
            GetNotificationNotificationsNotificationIdGetParameters,
            GetNotificationNotificationsNotificationIdGetError
          >
        | QueryFiltersByQueryKey<
            GetNotificationNotificationsNotificationIdGetSchema,
            GetNotificationNotificationsNotificationIdGetData,
            TInfinite,
            GetNotificationNotificationsNotificationIdGetParameters,
            GetNotificationNotificationsNotificationIdGetError
          >
    ): void;
    /** @summary Get Notification */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetNotificationNotificationsNotificationIdGetSchema,
            GetNotificationNotificationsNotificationIdGetData,
            TInfinite,
            GetNotificationNotificationsNotificationIdGetParameters,
            GetNotificationNotificationsNotificationIdGetError
          >
        | QueryFiltersByQueryKey<
            GetNotificationNotificationsNotificationIdGetSchema,
            GetNotificationNotificationsNotificationIdGetData,
            TInfinite,
            GetNotificationNotificationsNotificationIdGetParameters,
            GetNotificationNotificationsNotificationIdGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Get Notification */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetNotificationNotificationsNotificationIdGetSchema,
            GetNotificationNotificationsNotificationIdGetData,
            TInfinite,
            GetNotificationNotificationsNotificationIdGetParameters,
            GetNotificationNotificationsNotificationIdGetError
          >
        | QueryFiltersByQueryKey<
            GetNotificationNotificationsNotificationIdGetSchema,
            GetNotificationNotificationsNotificationIdGetData,
            TInfinite,
            GetNotificationNotificationsNotificationIdGetParameters,
            GetNotificationNotificationsNotificationIdGetError
          >
    ): number;
    schema: GetNotificationNotificationsNotificationIdGetSchema;
    types: {
      parameters: GetNotificationNotificationsNotificationIdGetParameters;
      data: GetNotificationNotificationsNotificationIdGetData;
      error: GetNotificationNotificationsNotificationIdGetError;
    };
  };
}
/** @summary Get Notifications */
export const getNotificationsNotificationsGet = {
  schema: {
    method: 'get',
    url: '/notifications',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetNotificationsNotificationsGetSchema;
  [QraftServiceOperationsToken]: NotificationsService['getNotificationsNotificationsGet'];
};
/** @summary Get Notification */
export const getNotificationNotificationsNotificationIdGet = {
  schema: {
    method: 'get',
    url: '/notifications/{notification_id}',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetNotificationNotificationsNotificationIdGetSchema;
  [QraftServiceOperationsToken]: NotificationsService['getNotificationNotificationsNotificationIdGet'];
};
export const notificationsService = {
  getNotificationsNotificationsGet,
  getNotificationNotificationsNotificationIdGet,
} as const;
type GetNotificationsNotificationsGetSchema = {
  method: 'get';
  url: '/notifications';
  security: ['HTTPBearer'];
};
type GetNotificationsNotificationsGetParameters = paths['/notifications']['get']['parameters'];
type GetNotificationsNotificationsGetData =
  paths['/notifications']['get']['responses']['200']['content']['application/json'];
type GetNotificationsNotificationsGetError =
  paths['/notifications']['get']['responses']['422']['content']['application/json'];
type GetNotificationNotificationsNotificationIdGetSchema = {
  method: 'get';
  url: '/notifications/{notification_id}';
  security: ['HTTPBearer'];
};
type GetNotificationNotificationsNotificationIdGetParameters =
  paths['/notifications/{notification_id}']['get']['parameters'];
type GetNotificationNotificationsNotificationIdGetData =
  paths['/notifications/{notification_id}']['get']['responses']['200']['content']['application/json'];
type GetNotificationNotificationsNotificationIdGetError =
  paths['/notifications/{notification_id}']['get']['responses']['422']['content']['application/json'];
